import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

export default function ModalCustomerPortfolio(props) {
  const customerP = props.model;

  const [zones, setZones] = useState([]);
  const [divitions, setDivitions] = useState([]);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listDivitions() {
    let response = await wsGetAll('base/layer-divition');
    if (response.success) setDivitions(response.data);
  }

  useEffect(() => {
    listZones();
    listDivitions();
  }, []);

  return (
    <Modal
      title="Cartera"
      model={customerP}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/customer-portfolio"
      state
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={!!customerP ? customerP.code : ''}
        required
      />
      <TextField
        label="Descripción"
        type="text"
        fullWidth
        name="description"
        margin="normal"
        defaultValue={!!customerP ? customerP.description : ''}
        required
      />
      <FormControl fullWidth size="small" margin="normal">
        <InputLabel>Zona</InputLabel>
        <Select
          defaultValue={!!customerP ? customerP.base_zone_id || '' : ''}
          inputProps={{
            name: 'base_zone_id'
          }}
        >
          {zones.map((item, i) => {
            return (
              <MenuItem value={item.id} key={i}>
                {item.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl fullWidth size="small" margin="normal">
        <InputLabel>Divición</InputLabel>
        <Select
          defaultValue={!!customerP ? customerP.divition_id || '' : ''}
          inputProps={{
            name: 'divition_id'
          }}
        >
          {divitions.map((item, i) => {
            return (
              <MenuItem value={item.id} key={i}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}
